/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductAdministrativeProceduresList } from '../models/PaginatedProductAdministrativeProceduresList';
import type { PatchedProductAdministrativeProcedures } from '../models/PatchedProductAdministrativeProcedures';
import type { ProductAdministrativeProcedures } from '../models/ProductAdministrativeProcedures';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsAdministrativeProceduresService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductAdministrativeProceduresList
     * @throws ApiError
     */
    public productsAdministrativeProceduresList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedProductAdministrativeProceduresList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-administrative-procedures/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ProductAdministrativeProcedures
     * @throws ApiError
     */
    public productsAdministrativeProceduresCreate({
        requestBody,
    }: {
        requestBody: ProductAdministrativeProcedures,
    }): CancelablePromise<ProductAdministrativeProcedures> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-administrative-procedures/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductAdministrativeProcedures
     * @throws ApiError
     */
    public productsAdministrativeProceduresRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product administrative procedures.
         */
        id: number,
    }): CancelablePromise<ProductAdministrativeProcedures> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-administrative-procedures/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductAdministrativeProcedures
     * @throws ApiError
     */
    public productsAdministrativeProceduresUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product administrative procedures.
         */
        id: number,
        requestBody: ProductAdministrativeProcedures,
    }): CancelablePromise<ProductAdministrativeProcedures> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-administrative-procedures/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductAdministrativeProcedures
     * @throws ApiError
     */
    public productsAdministrativeProceduresPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product administrative procedures.
         */
        id: number,
        requestBody?: PatchedProductAdministrativeProcedures,
    }): CancelablePromise<ProductAdministrativeProcedures> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-administrative-procedures/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsAdministrativeProceduresDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product administrative procedures.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-administrative-procedures/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
